export default "__VITE_ASSET__f27fce8d__"